import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router"

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'Foxline ERP';

  getLanguage():string{
    if (localStorage){
        return localStorage['language'] || "";
    }
    else{
        return "";
    }
}

setLanguage(language: string){
    if (localStorage){
        localStorage['language'] = language;
    }
}

  constructor(public translate: TranslateService, private router:Router) {
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');
  }

  User:any;

  ngOnInit(): void {
   
  }
 
}
